import { CommonHttpOption } from "./../../base/common-http-option";
import { CoreService } from "./../../base/core";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class MarkManagementService {
  constructor(private coreService: CoreService) {}

  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() hideDeatail: EventEmitter<boolean> = new EventEmitter();
  @Output() hideGpDet: EventEmitter<boolean> = new EventEmitter();
// MarkType
  catList(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.MarkType.catList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
  getById(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.MarkType.catGetById + id,
      new CommonHttpOption().headers
    );
  }
  catAdd(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.MarkType.catAdd,
      data,
      new CommonHttpOption().headers
    );
  }
  catEdit(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.MarkType.catEdit,
      data,
      new CommonHttpOption().headers
    );
  }
  delete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.MarkType.catDelete,
      new CommonHttpOption().headers,
      data
    );
  }
  ////  * نمرات *
  // لیست انواع نمرات
  list(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.MarkType.list,
      data,
      new CommonHttpOption().headers
    );
  }
//ثبت انواع نمرات
  add(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.MarkType.add,
      data,
      new CommonHttpOption().headers
    );
  }
  //ویرایش انواع نمرات
  edit(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.MarkType.edit,
      data,
      new CommonHttpOption().headers
    );
  }


  ////  * MarkClassification Id => EducationPackage *

  // لیست 
  markClassificationList(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.MarkClassification.list,
      data,
      new CommonHttpOption().headers
    );
  }
//لیست نوع طبقه بندی نمرات در هنگام استفاده از کمبو H

  typeComboList(page: number =0 , pageSize: number = 0): Observable<any> {
    return this.coreService.get(
      ServiceRoute.MarkClassification.typeComboList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

//ثبت 
markClassificationAdd(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.MarkClassification.add,
      data,
      new CommonHttpOption().headers
    );
  }

  //ویرایش 
  markClassificationEdit(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.MarkClassification.edit,
      data,
      new CommonHttpOption().headers
    );
  }
}
